import React from 'react';
import Footer from '../components/Footer';

const ContactUs: React.FC = () => (
  <div className="max-w-xl mx-auto py-12 px-4 text-center pb-20">
    <h1 className="text-3xl font-bold mb-4 text-primary">Contact Us</h1>
    <p className="text-lg text-secondary mb-6">
      Have questions or need support? Reach out to us and we’ll get back to you as soon as possible.
    </p>
    <div className="bg-white rounded-lg shadow p-6">
      <form className="space-y-4">
        <input type="text" placeholder="Your Name" className="w-full border rounded px-3 py-2" required />
        <input type="email" placeholder="Your Email" className="w-full border rounded px-3 py-2" required />
        <textarea placeholder="Your Message" className="w-full border rounded px-3 py-2" rows={4} required />
        <button type="submit" className="btn-primary w-full">Send Message</button>
      </form>
      <div className="mt-6 text-secondary">
        Or email us at <a href="mailto:support@artistdesk.com" className="text-primary underline">support@artistdesk.com</a>
      </div>
    </div>
    <Footer />
  </div>
);

export default ContactUs;
